import VdpModal from 'components/Vdp/Modal';
import { ResponseRecord } from 'types/Apis/SearchResponse';
import useEvents from 'lib/hooks/useEvents';
import { useContext } from 'react';
import VdpEventContext from 'contexts/VdpEventContext';
import closeEvent from 'lib/Tracking/Vdp/Quickpicks/ModalCloseEvent';
import QuickPicks from '.';

interface Props {
  vehicles?: ResponseRecord[];
  isLoading: boolean;
  isOpen: boolean;
  close: () => void;
}

export default function Modal({ vehicles, isLoading, isOpen, close }: Props): JSX.Element {
  const logger = useEvents();
  const { trackingParams } = useContext(VdpEventContext);

  function onModalClose(): void {
    logger.log(closeEvent({ trackingParams }));
    close();
  }

  return (
    <VdpModal isOpen={isOpen} onRequestClose={onModalClose} withCloseButton={false}>
      <QuickPicks isLoading={isLoading} vehicles={vehicles || []} close={close} />
    </VdpModal>
  );
}
